import OrderSummary from "../../../components/checkout/mainContentBox/OrderSummary";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {SHIPPING_TYPES} from "../../../models/ShippingTypes";
import {acceptOrder, assignPaymentToOrder, getOrderState, setFreePayment} from "../../../actions/order";
import Configuration from "../../../Configuration";
import {checkoutPageStepSet} from "../../../reducers/orderReducer";
import {OrderState} from "../../../models/Order";
import type {OrderItemsResponse} from "../../../models/Order";
import type {PaymentMethod} from "../../../api/PaymentApi";
import {CouponState} from "../../../models/Coupon";
import {CHECKOUT_PAGE_STATUS} from "../../../components/checkout/CheckoutPage";

const mapStateToProps = (state, ownProps) => {
	const items = state.cart.items;
	const {SHIPPING, MOUNT, PICKUP} = SHIPPING_TYPES;
	const withShipping = items.some(item => item.shippingMethod === SHIPPING);
	const withMounting = items.some(item => item.shippingMethod === MOUNT);
	const withPickup = items.some(item => item.shippingMethod === PICKUP);
	const myOrder: ?OrderItemsResponse = state.order.order;
	let shippingText;

	if (withShipping) {
		shippingText = ownProps.t("cart.expectedDeliveryDate.expectedDeliveryDateDefault",
			{
				min: Math.max(...state.cart.items.map(item => item.shippingMethod === "SHIPPING" ? item.product.distributionChannels.shipping.minSupplyDays : 0)),
				max: Math.max(...state.cart.items.map(item => item.shippingMethod === "SHIPPING" ? item.product.distributionChannels.shipping.maxSupplyDays : 0))
			}
		);
	} else {
		shippingText = ownProps.t("cart.shipping.pickup");
	}

	return {
		items: state.cart.items,
		adress: state.order.adress,
		shippingText,
		withPickup,
		showPickupLocation: state.location.pickupLocation && (withMounting || withPickup),
		legalTerms: state.config.legalTerms,
		euShop: !!state.config.euShop,
		dealerId: state.config.dealerId,
		notificationUrl: Configuration.value("apiNotificationUrl"),
		paymentFacility: state.cart.paymentFacility || {},
		paymentMethods: state.cart.paymentMethods,
		paymentErrors: state.cart.assignPaymentErrors,
		isAllShipping: !items.some(item => item.shippingMethod !== SHIPPING),
		isAssigningPayment: state.cart.isAssigningPayment,
		orderIsCreated: !!(myOrder && myOrder.orderNo),
		orderPayedFullyByCoupon: !!(state.coupon.coupon && state.coupon.coupon.coupon &&
			state.coupon.coupon.couponState && CouponState.isValid(state.coupon.coupon.couponState) &&
			myOrder && myOrder.orderItems && state.order.totalBillingAmount &&
			state.coupon.coupon.coupon.eligibleAmount && state.order.totalBillingAmount.cost <= 0),
        paymentAuthorizationFailed: state.order.paymentAuthorizationFailed,
        orderState: state.order.orderState || OrderState.UNDEFINE,
        orderNo: myOrder ? myOrder.orderNo : null,
        paymentVerified: state.order.paymentVerified,
        paymentVerificationTriggered: state.order.paymentAuthorizationRunning,
    };
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitOrder: () => {
			dispatch(acceptOrder());
		},
        editBillingAddress: () => {
            dispatch(checkoutPageStepSet(CHECKOUT_PAGE_STATUS.ADRESS));
        },
        assignPaymentMethod: (method: PaymentMethod) => {
            dispatch(assignPaymentToOrder(method));
        },
        setOrderFullyPayedByCoupon: () => {
            dispatch(setFreePayment());
        },
        getOrderState: (orderNo) => {
            dispatch(getOrderState(orderNo));
        },
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderSummary));
